module.exports = __webpack_public_path__ + "img/csr_111123_D.3f9dc896.jpg";